import { DefaultService } from "../default";

class NotificationsService extends DefaultService {
  static resourceURL = "notifications/";

  static readAll(params = {}, headers = {}, responseType = null) {
    return this.execute("read_all/", "POST", null, params, headers, responseType);
  }

  static read(id, params = {}, headers = {}, responseType = null) {
    return this.execute(`${id}/read/`, "POST", null, params, headers, responseType);
  }
}

export { NotificationsService };